import { Component } from '@angular/core';
import { Globals } from '../../globals/Globals';
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';
import { RouterConst } from '../../globals/RoutersConst';
import { SuperClass } from '../../superclass/SuperClass';
import { HttpClient } from '@angular/common/http';
import { DashboardDataService } from '../../services/dashboard-data.service';
import { WsService } from '../../services/websocket/WsService';
import { ClientsService } from '../../services/clients/clients.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent extends SuperClass {
  initials: string;

  yw_cpb_username = '';
  yw_cpb_password = '';
  is_ikea = false;

  constructor(
    private router: Router,
    private dashboardDataService: DashboardDataService,
    private clientsService: ClientsService,
    private wsService: WsService,
    private httpClient: HttpClient,
    private cookiesService: CookieService,
  ) {
    super(
      clientsService,
      wsService,
      dashboardDataService,
      httpClient,
      cookiesService,
    );
  }

  login_me_softly() {
    /*Globals.SERVER_ADDR = "/server";
    if(this.is_ikea)
      Globals.SERVER_ADDR = "/ikea/server";*/

    const credentials = {
      username: this.yw_cpb_username,
      password: this.yw_cpb_password,
    };
    this.http_login(credentials, data => this.handleData_login(data));
  }

  enter(e) {
    if (e.keyCode === 13) {
      this.login_me_softly();
    }
  }

  reloadData(): void {}

  getWebSocketIdentifier(): string {
    return undefined;
  }

  private handleData_login(data: any) {
    if (data.result === Globals.RESPONSE_RESULT_SUCCESS) {
      this.initials = data.payload.firstName + ' ' + data.payload.lastName;
      localStorage.setItem('initials', this.initials);
      this.setToken(data.securityToken);
      //LAO add default_client_id to cookie
      this.setClientId(data.payload.clientId);

     // this.router.navigate(['/' + RouterConst.MAIN]);
      this.router.navigateByUrl(`${RouterConst.MAIN}/(sub:key-user-metrics)`);

   }
  }
  private setToken(securityToken: string) {
    Globals.TOKEN = securityToken;
    this.cookiesService.set(Globals.COOKIES_TOKEN, securityToken);
  }
  private setClientId(clientId: string) {
    this.cookiesService.set(Globals.COOKIES_CLIENT_ID, clientId);
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/login/login.component.ts